module.exports = __webpack_public_path__ + "img/Wing_feathers_DiffuseColor.ee120c1.png";